import React from 'react';
import { Provider } from 'react-redux';
import { applyRouterMiddleware, Router } from 'react-router';
import { useScroll } from 'react-router-scroll';
import ReactGA from 'react-ga';

import Routes from './Routes';

export default class Root extends React.Component {
    constructor() {
        super();

        if(process.env.REACT_APP_ENVIRONMENT === 'production') {
            ReactGA.initialize('UA-127378738-1');
        }
    }

    logPageView() {
        if(process.env.REACT_APP_ENVIRONMENT === 'production') {
            ReactGA.set({page: window.location.pathname});
            ReactGA.pageview(window.location.pathname);
        }
    }

    render() {
        let { history, store } = this.props;
        return (
            <Provider store={store}>
                <Router history={history} routes={Routes} render={applyRouterMiddleware(useScroll())} onUpdate={this.logPageView.bind(this)} />
            </Provider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Root/Root.js